import React, { useState, Fragment, useEffect, useRef, useContext } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { Controller, useForm } from 'react-hook-form';
import Loading from '../shared/Loading';
import Constants from '../../Constants';
import { useFetchDate } from './useFetchDate';
import { EirConfirmDialog } from './EirConfirmDialog';
import { EirPrepayToPrepayPort } from './EirPrepayToPrepayPort';
import { usePortingStyle } from './usePortingStyle';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { useApolloClient } from '@apollo/client';
import ENDPOINT from '../graphql/GraphQLConstants';
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import { PORTING_ACCOUNT_TYPE } from '../eir-prepay-constants/ApplicationConstants';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import PubSub from 'pubsub-js';
import {
    Grid,
    TextField,
    Tooltip,
    Icon,
    Paper,
    RadioGroup,
    Radio,
    FormControlLabel,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
} from '@material-ui/core';
import EirOtp from '../eir-otp/EirOtp';
import { CheckoutContext } from '../eir-checkout/EirCheckoutContainer';
import { primaryText } from '../../utils/CssGlobalVariables';

const theme = createMuiTheme({
    typography: {
        textTransform: 'none',
        textAlign: 'left',
        letterSpacing: '0px',
        fontFamily: 'gt-walsheim-regular !important',
        fontSize: '1rem !important',
        opacity: 1,
    },
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: '14px',
            },
        },
        MuiFormHelperText: {
            root: {
                fontSize: 14,
                color: '#e40046',

                '&$error': {
                    fontSize: 14,
                    color: '#e40046',
                },
            },
        },
        MuiFormLabel: {
            asterisk: {
                color: '#f44336;',
            },
        },
        MuiTextField: {
            root: {
                fontSize: '16px',
                '@media (min-width:770px) and (max-width: 1024px)': {
                    fontSize: '14px',
                },
            },
        },
        MuiInputLabel: {
            shrink: {
                fontSize: '16px',
                '@media (min-width:279px) and (max-width: 280px)': {
                    fontSize: '15px',
                },
                '@media (min-width:770px) and (max-width: 1024px)': {
                    fontSize: '14px',
                },
                '@media (min-width:768px) and (max-width: 769px)': {
                    fontSize: '14px',
                },
            },
            root: {
                color: 'black',
                fontSize: '14px',
                '@media (min-width:767px) and (max-width: 767px)': {
                    fontSize: '13px',
                },
                '@media (min-width:279px) and (max-width: 280px)': {
                    fontSize: '10px',
                },
                '@media (min-width:768px) and (max-width: 1024px)': {
                    fontSize: '12px',
                },
                '&$disabled': {
                    // increase the specificity for the pseudo class
                    color: 'black',
                },
            },
        },
    },
    palette: {
        primary: {
            main: '#493553',
        },
    },
});

export default function EirPorting(props) {
    const graphql = useApolloClient();

    const yesToggleBtnRef = useRef(null);
    const noToggleBtnRef = useRef(null);
    const classes = usePortingStyle();
    const [isLoading, setIsLoading] = useState(false);
    const DATE_FORMAT = 'DD/MM/YYYY';
    const { register, control, errors, handleSubmit } = useForm({
        reValidateMode: 'onChange',
    });
    const [keepMobileNumber, setkeepMobileNumber] = React.useState('no');
    const [layoutDisplay, setLayoutDisplay] = React.useState(false);
    const [MobileValidationStatus, setMobileValidationStatus] = React.useState(false);
    const [mobileValidationerror, setMobileValidationerror] = React.useState(false);
    const [phoneNumberEmpty, setPhoneNumberEmpty] = React.useState(false);
    const [validPhoneNumber, setvalidPhoneNumber] = React.useState('');
    const [timeRangeErrorMsg, setTimeRangeErrorMsg] = React.useState(false);
    const [selectedTime, setSelectedTime] = React.useState('');
    const [accountType, setAccountType] = React.useState('');
    const [currentProviderName, setCurrentProviderName] = React.useState('');
    const [currentProviderId, setCurrentProviderId] = React.useState('');
    const [providerAccountNumber, setProviderAccountNumber] = React.useState('');
    const [showproviderAccountNumber, setShowproviderAccountNumber] = React.useState(false);
    const [noEmptyField, setNoEmptyField] = React.useState(false);
    const [readonly, setReadonly] = React.useState(false);
    const [confirmField, setConfirmField] = React.useState(false);
    const [prevTime, setPrevTime] = React.useState('');
    const [prevDate, setPrevDate] = React.useState('');
    const [prevAccType, setPrevAccType] = React.useState('');
    const [prevAccNumber, setPrevAccNumber] = React.useState('');
    const [intermediateStatus, setIntermediateStatus] = React.useState(false);
    // const [modalOpenStatus, setModalOpenStatus] = React.useState(false);
    const [catalogDiscountId, setcatalogDiscountId] = React.useState('');
    const offerId = JSON.parse(localStorage.getItem('offerId'));
    const prospectUuid = localStorage.getItem('prospectUuid');
    const [addDisount, setAddDiscount] = React.useState(true);
    const refs = { yesToggleBtnRef, noToggleBtnRef };
    const [confirmErr, setConfirmErr] = React.useState('');
    const { cartDetails } = useContext(CheckoutContext);

    const [
        minDate,
        maxDate,
        selectedDate,
        handleDateChange,
        startingTime,
        endingTime,
        timeRangeError,
        selctedDatewithoutTimeZone,
    ] = useFetchDate();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [openModal, setOpenModal] = React.useState(false);
    const setdiscount = response => {
        setAddDiscount(response);
    };
    const setConfirmErrorMsg = response => {
        setConfirmErr(response);
    };

    useEffect(() => {
        if (props.details.discount != null) {
            setAddDiscount(false);
            yesToggleBtnRef.current.click();
        } else {
            props.setconfirmBtnStatus(true);
        }

        let offerName = 'Simplicity';

        const fetchDiscount = async () => {
            try {
                const res = await graphql.query({
                    query: ENDPOINT.GET_DISCOUNT,
                    variables: { offerName: offerName },
                });

                if (res.data.discounts) {
                    setcatalogDiscountId(res.data.discounts[0].catalogDiscountCode);
                }
            } catch (err) {
                // handle err msg
            }
        };
        fetchDiscount();
        if (cartDetails.port) {
            setvalidPhoneNumber(cartDetails.port.phoneNumber);
            const portTime = cartDetails.port.portStartDateTime.split('T')[1];
            setSelectedTime(portTime.replace(':00Z', ''));
            setkeepMobileNumber('yes');
            setMobileValidationStatus(true);
            setCurrentProviderName(cartDetails.port.otherNetworkName);
            setAccountType(cartDetails.port.type);
            setProviderAccountNumber(cartDetails.port.otherNetworkAccountNumber);
            setCurrentProviderId(cartDetails.port.otherNetworkId);
            setConfirmField(true);
        }

        var tempElement = document.createElement('style');
        tempElement.id = 'dynamicStyle';
        document.getElementsByTagName('head')[0].appendChild(tempElement);
        document.querySelector('#dynamicStyle').innerText =
            "input[type='time']::-webkit-calendar-picker-indicator{background:url('/opencms/export/sites/default/.galleries/eir/icons/timer-icon.svg'); background-repeat: no-repeat;outline:none;}";
    }, []);
    // enable the confirm button only after the entire form is filled
    useEffect(() => {
        if (
            validPhoneNumber != '' &&
            currentProviderId != '' &&
            accountType != '' &&
            currentProviderName != '' &&
            selctedDatewithoutTimeZone != '' &&
            selectedTime != '' &&
            !timeRangeErrorMsg
        ) {
            if (accountType == 'Postpay single line' || accountType == 'Postpay multiline') {
                if (providerAccountNumber != '') {
                    setNoEmptyField(true);
                } else {
                    setNoEmptyField(false);
                }
            } else {
                setNoEmptyField(true);
            }
        }
    }, [
        validPhoneNumber,
        currentProviderId,
        accountType,
        currentProviderName,
        providerAccountNumber,
        selctedDatewithoutTimeZone,
        selectedTime,
        timeRangeErrorMsg,
    ]);
    // final form submission
    const onSubmit = async () => {
        if (validPhoneNumber == '') {
            setPhoneNumberEmpty(true);
            return false;
        } else if (!MobileValidationStatus) {
            setMobileValidationerror(true);
            return false;
        } else if (timeRangeErrorMsg) {
            return false;
        } else if (currentProviderName=='Meteor' && !((accountType == 'BILL_PAY_SINGLE_LINE' || accountType == 'BILL_PAY_MULTI_LINE'))) {
            setOpenModal(true);
        } else {
            setPhoneNumberEmpty(false);
            setMobileValidationerror(false);
            setIsLoading(true);
            setConfirmErr('');
            let addportObject = {
                prospectUuid: prospectUuid,
                cartOfferId: offerId,
                otherNetworkId: currentProviderId,
                otherNetworkName: currentProviderName,
                phoneNumber: validPhoneNumber,
                portStartDateTime: selctedDatewithoutTimeZone + 'T' + selectedTime + ':00Z',
                type: accountType,
            };
            if (providerAccountNumber != '') {
                addportObject.otherNetworkAccountNumber = providerAccountNumber;
            }
            try {
                const res = await graphql.mutate({
                    mutation: ENDPOINT.ADD_PORT,
                    variables: addportObject,
                });

                if (res.data.addPort) {
                    props.setconfirmBtnStatus(true);
                    setIsLoading(false);
                    setConfirmField(true);
                    setIntermediateStatus(false);
                    setConfirmErr('');
                }
            } catch (err) {
                setIsLoading(false);
                setConfirmField(false);
                setConfirmErr(err.message);
            }
            if (addDisount && props.details.device != null) {
                try {
                    const res = await graphql.mutate({
                        mutation: ENDPOINT.ADD_DISCOUNT,
                        variables: {
                            prospectUuid: prospectUuid,
                            cartOfferId: offerId,
                            catalogDiscountCode: catalogDiscountId,
                        },
                    });
                    if (res.data.addDiscount) {
                        PubSub.publish(
                            Constants.eventKeys.updatedCartDetails,
                            res.data.addDiscount
                        );
                    }
                } catch (err) {
                    //handle error here
                    setConfirmField(false);
                }
            }
        }
    };
    // hide and show account number field based on account type selection
    const handleAccountTypeChange = event => {
        let typeValue = event.target.value;
        setAccountType(event.target.value);
        if (typeValue == 'BILL_PAY_SINGLE_LINE' || typeValue == 'BILL_PAY_MULTI_LINE') {
            setShowproviderAccountNumber(true);
            setProviderAccountNumber('');
        } else {
            setShowproviderAccountNumber(false);
            setProviderAccountNumber('');
        }

        return event.target.value;
    };
    const handlemobileValidationerror = () => {
        setMobileValidationerror(false);
    };
    const handlephoneNumberEmpty = () => {
        setPhoneNumberEmpty(false);
    };

    const handleChange = event => {
        setkeepMobileNumber(event.target.value);
    };

    // get the operator name once the mobile number is validated
    const handleMobileValidationStatus = async response => {
        setIsLoading(true);
        if (response) {
            try {
                const res = await graphql.query({
                    query: ENDPOINT.GET_OPERATOR,
                    variables: { msisdn: validPhoneNumber },
                });
                if (res.data.operator) {
                    setCurrentProviderId(res.data.operator.network.id);
                    setCurrentProviderName(res.data.operator.network.networkName);
                    setIsLoading(false);
                    setMobileValidationStatus(response);
                }
            } catch (err) {
                //handle error here
            }
        }
    };

    const storeValidePhoneNumber = response => {
        setvalidPhoneNumber(response);
    };
    // hide and show functionality for radio buttons
    const handleToggleEvent = event => {
        if (event.target.value == 'yes') {
            if (intermediateStatus) {
                if (MobileValidationStatus) {
                    setMobileValidationStatus(true);
                } else {
                    setMobileValidationStatus(false);
                }
                if (
                    validPhoneNumber != '' &&
                    currentProviderId != '' &&
                    accountType != '' &&
                    currentProviderName != '' &&
                    selctedDatewithoutTimeZone != '' &&
                    selectedTime != '' &&
                    !timeRangeErrorMsg
                ) {
                    if (
                        accountType == 'Postpay single line' ||
                        accountType == 'Postpay multiline'
                    ) {
                        if (providerAccountNumber != '') {
                            setNoEmptyField(true);
                        } else {
                            setNoEmptyField(false);
                        }
                    } else {
                        setNoEmptyField(true);
                    }
                }
            } else {
                if (confirmField) {
                    if (selectedTime != '' || MobileValidationStatus) {
                        if (MobileValidationStatus) {
                            setMobileValidationStatus(true);
                        } else {
                            setMobileValidationStatus(false);
                        }

                        setNoEmptyField(false);
                        setReadonly(false);
                    }
                } else {
                    props.setconfirmBtnStatus(false);
                    setReadonly(false);
                    setvalidPhoneNumber('');
                    handleDateChange(null);
                    setSelectedTime('');
                    setCurrentProviderName('');
                    setProviderAccountNumber('');
                    setAccountType('');
                    setMobileValidationStatus(false);
                    setShowproviderAccountNumber(false);
                }
            }

            setConfirmField(false);
            setLayoutDisplay(true);
            setDialogOpen(false);
        }

        if (event.target.value == 'no') {
            if (confirmField) {
                setSelectedTime(selectedTime);
                setvalidPhoneNumber(validPhoneNumber);
                setConfirmField(true);
            } else {
                setPhoneNumberEmpty(false);
                setMobileValidationerror(false);

                setReadonly(false);
            }
            setDialogOpen(true);
            setNoEmptyField(false);
            setLayoutDisplay(false);
            setIsLoading(false);
        }
        const radioLayout = document.querySelectorAll('.purpleLayout');

        for (var i = 0; i < radioLayout.length; i++) {
            radioLayout[i].classList.remove('purpleLayout');
        }
        event.target.parentNode.parentNode.parentNode.classList.add('purpleLayout');
    };

    const handleTimeChange = event => {
        const time = event.target.value;
        if (time < startingTime || time > endingTime) {
            setTimeRangeErrorMsg(true);
        } else {
            setTimeRangeErrorMsg(false);
        }

        setSelectedTime(event.target.value);
        return event.target.value;
    };
    // edit functionality to change move date and time
    const handleEditFields = e => {
        e.preventDefault();
        setConfirmErr('');
        setPrevTime(selectedTime);
        setPrevAccType(accountType);
        setPrevAccNumber(providerAccountNumber);
        if (cartDetails.port) {
            const portDate = moment(cartDetails.port.portStartDateTime.split('T')[0]);
            handleDateChange(portDate);
            setPrevDate(portDate);
        } else {
            handleDateChange(selectedDate);
            setPrevDate(selectedDate);
        }

        setConfirmField(false);
        setNoEmptyField(false);
        setReadonly(true);
        props.setconfirmBtnStatus(false);
        setAddDiscount(false);
        setLayoutDisplay(true);
    };
    // cancel the modified move date and time
    const handleCancel = () => {
        props.setconfirmBtnStatus(true);
        handleDateChange(prevDate);
        setSelectedTime(prevTime);
        setAccountType(prevAccType);
        setProviderAccountNumber(prevAccNumber);
        setTimeout(function () {
            setConfirmField(true);
        }, 500);
    };
    const handleCofirmationStatus = response => {
        setConfirmField(response);

        if (!confirmField) {
            handleDateChange(null);
            setSelectedTime('');
            setCurrentProviderName('');
            setProviderAccountNumber('');
            setAccountType('');
            setvalidPhoneNumber('');
            setMobileValidationStatus(false);
            setLayoutDisplay(false);
            setPhoneNumberEmpty(false);
            setMobileValidationerror(false);
            setReadonly(false);

            setConfirmField(false);
            setShowproviderAccountNumber(false);
            noToggleBtnRef.current.click();
        }
    };
    const handleIntermediateStatus = response => {
        setIntermediateStatus(response);
    };
    const handleModalOpenStatus = response => {
        setOpenModal(response);
    };
    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <Paper className={classes.paper}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={classes.eirPorting}>
                            {dialogOpen && (
                                <EirConfirmDialog
                                    isDevice={props.details.device}
                                    setconfirmBtnStatus={props.setconfirmBtnStatus}
                                    setConfirmErrorMsg={setConfirmErrorMsg}
                                    refs={refs}
                                    setdiscount={setdiscount}
                                    catalogDiscountId={catalogDiscountId}
                                    offerId={offerId}
                                    prospectUuid={prospectUuid}
                                    handleEditFields={handleEditFields}
                                    handleCofirmationStatus={handleCofirmationStatus}
                                    validPhoneNumber={validPhoneNumber}
                                    storeValidePhoneNumber={storeValidePhoneNumber}
                                    confirmField={confirmField}
                                    MobileValidationStatus={MobileValidationStatus}
                                    selectedTime={selectedTime}
                                    selectedDate={selectedDate}
                                    handleIntermediateStatus={handleIntermediateStatus}
                                />
                            )}
                            {openModal && (
                                <EirPrepayToPrepayPort
                                    handleModalOpenStatus={handleModalOpenStatus}
                                />
                            )}
                            <Grid container spacing={6}>
                                <Grid item xs={12} sm={12} md={9}>
                                    <RadioGroup
                                        row
                                        name='keepMobileNumber'
                                        value={keepMobileNumber}
                                        onChange={handleChange}>
                                        <h4 className='radioText'>
                                            Do you want to move your mobile number to eir prepay?
                                            <Tooltip
                                                enterTouchDelay={20}
                                                leaveTouchDelay={15000}
                                                title="Select 'Yes' if you want to move your number from another mobile network or eir Bill pay."
                                                style={{ overflow: 'visible' }}
                                                placement='bottom'>
                                                <HelpOutlinedIcon
                                                    color={primaryText}
                                                    className='questionIcon'
                                                />
                                                {/* <div className='questionIcon'></div> */}
                                            </Tooltip>
                                        </h4>
                                        <FormControlLabel
                                            className='radioLayout greylLayout mobileViewLeft'
                                            value='yes'
                                            control={
                                                <Radio
                                                    color={primaryText}
                                                    onClick={handleToggleEvent}
                                                    ref={yesToggleBtnRef}
                                                />
                                            }
                                            label='Yes'
                                        />

                                        <FormControlLabel
                                            className='radioLayout greylLayout purpleLayout mobileViewRight'
                                            value='no'
                                            control={
                                                <Radio
                                                    ref={noToggleBtnRef}
                                                    color='primary'
                                                    onClick={handleToggleEvent}
                                                />
                                            }
                                            label='No'
                                        />
                                    </RadioGroup>
                                </Grid>

                                {!confirmField && (
                                    <Grid item xs={5} md={3} className='mobileHide'>
                                        {layoutDisplay && !confirmField && (
                                            <span style={{ float: 'right' }}>
                                                <span className='required'>*</span>Required fields
                                            </span>
                                        )}
                                    </Grid>
                                )}
                            </Grid>
                            {confirmField && (
                                <Grid container spacing={8}>
                                    <Grid item xs={12} sm={10} md={10}>
                                        <Grid container>
                                            <Grid item xs={12} sm={5} md={4} className='editLayout'>
                                                <div className='tickright tickposition'>
                                                    <span>
                                                        Phone number: &nbsp;{validPhoneNumber}
                                                    </span>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={4} md={4} className='editLayout'>
                                                {' '}
                                                <div className='tickright tickposition'>
                                                    <span>
                                                        Move date:&nbsp;{' '}
                                                        {selctedDatewithoutTimeZone
                                                            .split('-')
                                                            .reverse()
                                                            .join('/')}
                                                    </span>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={3} md={4} className='editLayout'>
                                                {' '}
                                                <div className='tickright tickposition'>
                                                    <span>
                                                        Move time:&nbsp; {selectedTime}{' '}
                                                        {/* {selectedTime >= '12' ? 'pm' : 'am'} */}
                                                    </span>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={2} md={2} className='mobileViewEdit'>
                                        {/* <div className='mobileViewEdit'> */}
                                        <a href='#' onClick={handleEditFields}>
                                            {' '}
                                            <div className='radioLayout EditIcon EditText'>
                                                {' '}
                                                <span className='AlignEdit'>Edit</span>
                                            </div>
                                        </a>
                                        {/* </div> */}
                                    </Grid>
                                </Grid>
                            )}
                            {layoutDisplay && !confirmField && (
                                <div>
                                    <div className='eirotpComp'>
                                        <EirOtp
                                            handleMobileValidationStatus={
                                                handleMobileValidationStatus
                                            }
                                            MobileValidationStatus={MobileValidationStatus}
                                            storeValidePhoneNumber={storeValidePhoneNumber}
                                            phoneNumberEmpty={phoneNumberEmpty}
                                            mobileValidationerror={mobileValidationerror}
                                            handlephoneNumberEmpty={handlephoneNumberEmpty}
                                            handlemobileValidationerror={
                                                handlemobileValidationerror
                                            }
                                            validPhoneNumber={validPhoneNumber}
                                        />
                                        {(phoneNumberEmpty || mobileValidationerror) && (
                                            <Grid item xs={12} sm={12}>
                                                <Grid item xs={12} sm={4}></Grid>
                                            </Grid>
                                        )}
                                    </div>
                                    {isLoading && <Loading />}
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={3} md={3}>
                                            <div>
                                                <MuiPickersUtilsProvider
                                                    utils={MomentUtils}
                                                    moment={moment}>
                                                    <Fragment>
                                                        <Controller
                                                            as={
                                                                <KeyboardDatePicker
                                                                    inputProps={{
                                                                        readOnly: true,
                                                                    }}
                                                                />
                                                            }
                                                            required
                                                            fullWidth
                                                            inputVariant='outlined'
                                                            format={DATE_FORMAT}
                                                            autoOk
                                                            id='moveDate'
                                                            name='moveDate'
                                                            label='Move date'
                                                            variant='outlined'
                                                            size='small'
                                                            maxDate={maxDate}
                                                            minDate={minDate}
                                                            keyboardIcon={
                                                                <Icon className='calenderIcon'></Icon>
                                                            }
                                                            inputRef={register}
                                                            control={control}
                                                            onChange={([date]) => {
                                                                handleDateChange(date);

                                                                return moment(date);
                                                            }}
                                                            rules={{ required: true }}
                                                            // defaultValue={(moment((selectedDate)).isValid()) ? moment((selectedDate)) : null}
                                                            defaultValue={
                                                                selectedDate != null &&
                                                                selectedDate != 'null'
                                                                    ? moment(selectedDate).isValid()
                                                                        ? moment(selectedDate)
                                                                        : null
                                                                    : null
                                                            }
                                                        />
                                                        {errors.moveDate &&
                                                            errors.moveDate.type === 'required' && (
                                                                <span className='errorMessage'>
                                                                    Move date is required
                                                                </span>
                                                            )}
                                                    </Fragment>
                                                </MuiPickersUtilsProvider>
                                            </div>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={10}
                                            sm={3}
                                            md={3}
                                            className='mobilePaddingRight'>
                                            <div>
                                                <div
                                                    className={
                                                        selectedDate && selectedDate != 'null'
                                                            ? ''
                                                            : 'clockIcon'
                                                    }>
                                                    <Controller
                                                        as={
                                                            <TextField
                                                                type={
                                                                    selectedDate &&
                                                                    selectedDate != 'null'
                                                                        ? 'time'
                                                                        : 'text'
                                                                }
                                                                disabled={
                                                                    selectedDate &&
                                                                    selectedDate != 'null'
                                                                        ? false
                                                                        : true
                                                                }
                                                                InputLabelProps={{
                                                                    shrink:
                                                                        selectedDate &&
                                                                        selectedDate != 'null'
                                                                            ? true
                                                                            : false,
                                                                }}
                                                            />
                                                        }
                                                        required
                                                        id='prefferedTime'
                                                        name='prefferedTime'
                                                        label='Preferred time'
                                                        variant='outlined'
                                                        size='small'
                                                        fullWidth
                                                        defaultValue={selectedTime}
                                                        onChange={([event]) => {
                                                            return handleTimeChange(event);
                                                        }}
                                                        control={control}
                                                        inputRef={register}
                                                        rules={{ required: true }}
                                                    />
                                                </div>
                                                {errors.prefferedTime &&
                                                    errors.prefferedTime.type === 'required' && (
                                                        <span className='errorMessage'>
                                                            {' '}
                                                            Preferred time is required
                                                        </span>
                                                    )}
                                                {timeRangeErrorMsg && (
                                                    <span className='errorMessage'>
                                                        {timeRangeError}
                                                    </span>
                                                )}
                                            </div>
                                        </Grid>
                                        <Grid item xs={2} sm={1} className='mobileBorder'>
                                            {' '}
                                            <Tooltip
                                                enterTouchDelay={20}
                                                leaveTouchDelay={15000}
                                                title='Your move will start within an hour of your selected time and can take up to 24 hours to complete.'
                                                style={{ overflow: 'visible' }}
                                                placement='top-end'>
                                                <HelpOutlinedIcon
                                                    color='primary'
                                                    className='questionIcon'
                                                />
                                                {/* <div className='questionIcon'></div> */}
                                            </Tooltip>
                                        </Grid>
                                        {MobileValidationStatus && (
                                            <Fragment>
                                                <Grid
                                                    item
                                                    xs={1}
                                                    sm={5}
                                                    md={5}
                                                    className='mobileHideGrid'></Grid>
                                                <Grid item xs={12} sm={3} md={3}>
                                                    <div>
                                                        <Controller
                                                            as={
                                                                <TextField
                                                                    InputProps={{
                                                                        readOnly: MobileValidationStatus,
                                                                    }}
                                                                />
                                                            }
                                                            control={control}
                                                            fullWidth
                                                            id='currentProvider'
                                                            name='currentProvider'
                                                            label='Current provider'
                                                            variant='outlined'
                                                            size='small'
                                                            defaultValue={currentProviderName}
                                                            inputRef={register}
                                                            rules={{ required: true }}
                                                        />
                                                        {errors.currentProvider &&
                                                            errors.currentProvider.type ===
                                                                'required' && (
                                                                <span className='errorMessage'>
                                                                    Current provider is required
                                                                </span>
                                                            )}
                                                    </div>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={10}
                                                    sm={3}
                                                    md={3}
                                                    className='mobilePaddingRight'>
                                                    <div>
                                                        <FormControl
                                                            variant='outlined'
                                                            fullWidth
                                                            size='small'>
                                                            <InputLabel
                                                                className={classes.inputLabelStar}>
                                                                Account type
                                                            </InputLabel>
                                                            <Controller
                                                                as={
                                                                    <Select id='accountType'>
                                                                        {PORTING_ACCOUNT_TYPE.map(
                                                                            (
                                                                                accountType,
                                                                                index
                                                                            ) => (
                                                                                <MenuItem
                                                                                    key={index}
                                                                                    value={
                                                                                        accountType.value
                                                                                    }>
                                                                                    {
                                                                                        accountType.name
                                                                                    }
                                                                                </MenuItem>
                                                                            )
                                                                        )}
                                                                    </Select>
                                                                }
                                                                defaultValue={accountType}
                                                                onChange={([event]) => {
                                                                    return handleAccountTypeChange(
                                                                        event
                                                                    );
                                                                }}
                                                                control={control}
                                                                label='Account type'
                                                                name='accountType'
                                                                inputRef={register}
                                                                rules={{ required: true }}
                                                            />
                                                            {errors.accountType &&
                                                                errors.accountType.type ===
                                                                    'required' && (
                                                                    <span className='errorMessage'>
                                                                        Account type is required
                                                                    </span>
                                                                )}
                                                        </FormControl>
                                                    </div>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={2}
                                                    sm={1}
                                                    className='iconWidth mobileBorder'>
                                                    <Tooltip
                                                        enterTouchDelay={20}
                                                        leaveTouchDelay={15000}
                                                        title="Tell us if you're a Prepay or Postpay (pay by bill) customer with your current provider. If Postpay, let us know if there's just one (single) or multiple users on the account."
                                                        style={{ overflow: 'visible' }}
                                                        placement='top-end'>
                                                        <HelpOutlinedIcon
                                                            color='primary'
                                                            className='questionIcon'
                                                        />
                                                        {/* <div className='questionIcon'></div> */}
                                                    </Tooltip>
                                                </Grid>
                                                {!showproviderAccountNumber && (
                                                    <Grid item xs={10} md={3} sm={3}></Grid>
                                                )}
                                                {showproviderAccountNumber && (
                                                    <Fragment>
                                                        <Grid
                                                            item
                                                            xs={10}
                                                            md={3}
                                                            sm={3}
                                                            className='mobilePaddingRight'>
                                                            <div>
                                                                <Controller
                                                                    as={<TextField />}
                                                                    required
                                                                    control={control}
                                                                    fullWidth
                                                                    id='providerAccountNumber'
                                                                    name='providerAccountNumber'
                                                                    label='Current provider account number'
                                                                    variant='outlined'
                                                                    size='small'
                                                                    inputRef={register}
                                                                    defaultValue={
                                                                        providerAccountNumber
                                                                    }
                                                                    onChange={([event]) => {
                                                                        setProviderAccountNumber(
                                                                            event.target.value
                                                                        );
                                                                        return event.target.value;
                                                                    }}
                                                                    rules={{
                                                                        required: true,
                                                                        pattern: /^[0-9a-zA-Z \\.\\s]{1,24}$/,
                                                                    }}
                                                                />
                                                                {errors.providerAccountNumber &&
                                                                    errors.providerAccountNumber
                                                                        .type === 'pattern' && (
                                                                        <span className='errorMessage'>
                                                                            You must enter 24 or
                                                                            less characters
                                                                        </span>
                                                                    )}
                                                                {errors.providerAccountNumber &&
                                                                    errors.providerAccountNumber
                                                                        .type === 'required' && (
                                                                        <span className='errorMessage'>
                                                                            Provider account number
                                                                            is required
                                                                        </span>
                                                                    )}
                                                            </div>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={2}
                                                            sm={1}
                                                            className='iconWidth iconTab mobileBorder'>
                                                            <Tooltip
                                                                enterTouchDelay={20}
                                                                leaveTouchDelay={15000}
                                                                title='You will find this on your current provider account bill.'
                                                                style={{ overflow: 'visible' }}
                                                                placement='top-end'>
                                                                <HelpOutlinedIcon
                                                                    color='primary'
                                                                    className='questionIcon'
                                                                />
                                                                {/* <div className='questionIcon'></div> */}
                                                            </Tooltip>
                                                        </Grid>
                                                    </Fragment>
                                                )}
                                            </Fragment>
                                        )}
                                        {!readonly && (
                                            <Grid
                                                item
                                                xs={12}
                                                sm={MobileValidationStatus ? 2 : 5}
                                                md={MobileValidationStatus ? 2 : 5}>
                                                <input
                                                    type='submit'
                                                    value='Confirm'
                                                    className={
                                                        !noEmptyField || timeRangeErrorMsg
                                                            ? 'greyBtn'
                                                            : 'pupleBtn'
                                                    }
                                                    disabled={!noEmptyField || timeRangeErrorMsg}
                                                />
                                            </Grid>
                                        )}
                                        {readonly && (
                                            <Grid item xs={12} sm={12} md={12}>
                                                <div className='mobileFloat'>
                                                    <input
                                                        type='button'
                                                        value='Cancel'
                                                        className='cancelBtn'
                                                        onClick={handleCancel}
                                                    />
                                                    <input
                                                        type='submit'
                                                        value='Confirm'
                                                        className={
                                                            !noEmptyField ? 'greyBtn' : 'pupleBtn'
                                                        }
                                                        disabled={!noEmptyField}
                                                    />
                                                </div>
                                            </Grid>
                                        )}
                                    </Grid>
                                    {confirmErr != '' && (
                                        <span className='errorMessage'>{confirmErr}</span>
                                    )}
                                </div>
                            )}
                        </div>
                    </form>
                </Paper>
            </ThemeProvider>
        </Fragment>
    );
}
